const map = {
	"./01.jpg": 5477,
	"./02.jpg": 9226,
	"./03.jpg": 1415,
	"./04.jpg": 9068,
	"./05.jpg": 121,
	"./06.jpg": 3006,
	"./07.jpg": 1051,
	"./08.jpg": 9440,
	"./09.jpg": 8013,
	"./10.jpg": 3319,
	"./11.jpg": 8858,
	"./12.jpg": 3842,
	"./13.jpg": 9096,
	"./14.jpg": 1771,
	"./15.jpg": 6990
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4074;